/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorRequest = zod
	.object({
		praetor: zod.object({
			name: zod.string().optional().describe('Praetor name')
		})
	})
	.describe('Request body for creating or updating a praetor');

export type PraetorRequest = zod.input<typeof PraetorRequest>;
export type PraetorRequestOutput = zod.output<typeof PraetorRequest>;
